import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { useStyle } from "../../../Design/useStyle";
import { defaultStyles } from "./defaultStyles";

interface H2Props extends ComponentPropsWithRef<"h2"> {
  styles?: Record<string, StyleValue>;
  text: string;
}

export const H2 = forwardRef<HTMLHeadingElement, H2Props>(
  ({ text, styles = {}, ...rest }, ref) => {
    const styled = useStyle(theme => ({
      base: {
        color: theme.h2["theme-email-h2-color-text"],
        fontWeight: theme.h2["theme-email-h2-font-weight"],
        fontSize: theme.h2["theme-email-h2-font-size"],
        lineHeight: theme.h2["theme-email-h2-line-height"],
        letterSpacing: theme.h2["theme-email-h2-letter-spacing"],
      },
    }));
    const inlineStyles = parseStyles({
      styles,
      defaultStyles,
      ignoreDefaults: false,
    });

    return (
      <h2 ref={ref} style={styled({ style: inlineStyles })} {...rest}>
        {text}
      </h2>
    );
  },
);

H2.displayName = "H2";
